import proj4 from 'proj4';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { IMapSizes } from '../MapSizeContext';
import useMapTranslation from './useMapTranslation';

const useMapLocation = (monitor: string, sizes: IMapSizes) => {
  const monitorMap = useSelector((state: any) => state.executor.monitorMaps);
  const currentMonitor = monitorMap[monitor];
  const [corner, setCorners] = useState({
    leftUpperCorner: [],
    rightLowerCorner: [],
  });

  const translation = useMapTranslation(
    corner.leftUpperCorner,
    corner.rightLowerCorner,
    sizes
  );

  useEffect(() => {
    if (!currentMonitor.map) {
      return;
    }
    const map = currentMonitor.map.mapByScale[currentMonitor.zoomPosition];

    if (map) {
      console.log('setting corners', map);
      setCorners({
        leftUpperCorner: map.leftUpperCorner,
        rightLowerCorner: map.rightLowerCorner,
      });
    }
  }, [currentMonitor]);

  return translation;
};

export default useMapLocation;
